export default __webpack_public_path__ + "static/media/company-img.684f23a0.jpg";